import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { COMPANY } from '../data/company';
import { getCdnImageUrl } from '../lib/utils';

const TASK_CATEGORIES = [
  {
    id: 'reparationer',
    title: 'Reparationer',
    slug: 'reparationer',
    icon: 'fa-solid fa-screwdriver-wrench',
    category: 'Reparationer',
    image: 'https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/shutterstock-2727590971-rez.jpg',
    shortDescription: 'Reparation af defekte installationer, som vandhaner, døre og vinduer.',
    examples: ['Droppende vandhaner & toiletter', 'Justering af binderdøre & vinduer', 'Lapping af huller i gips/væg', 'Udskiftning af hængsler & greb'],
    tag: 'Hurtig udrykning',
    timeEst: 'Typisk 1-2 timer'
  },
  {
    id: 'montering',
    title: 'Montering',
    slug: 'montering',
    icon: 'fa-solid fa-hammer',
    category: 'Montering',
    image: 'https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2498.jpeg',
    shortDescription: 'Montering af møbler og inventar, inklusive skabe, hylder og billeder.',
    examples: ['Montering af TV på væg', 'Samling af IKEA / skabsmøbler', 'Ophængning af hylder & billeder', 'Opsætning af lamper & gardiner'],
    tag: 'Mest populære',
    timeEst: 'Typisk 1-3 timer'
  },
  {
    id: 'maling',
    title: 'Maling & Tapet',
    slug: 'maling-og-tapetsering',
    icon: 'fa-solid fa-paint-roller',
    category: 'Maling og tapetsering',
    image: 'https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2118.jpeg',
    shortDescription: 'Hjælp med maling og tapetsering, hvilket kan give dit hjem et friskt udseende.',
    examples: ['Maling af enkeltværelse eller stue', 'Maling af fodpaneler & døre', 'Opsætning af råhvidt tapet / filt', 'Opfriskning af træværk udendørs'],
    tag: 'Flot finish',
    timeEst: 'Typisk 1-2 dage'
  },
  {
    id: 'havearbejde',
    title: 'Havearbejde',
    slug: 'havearbejde',
    icon: 'fa-solid fa-leaf',
    category: 'Havearbejde',
    image: 'https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1314.jpeg',
    shortDescription: 'Havearbejde og vedligeholdelse af udendørsområder, herunder græsslåning og beskæring af buske.',
    examples: ['Græsslåning & kantskæring', 'Beskæring af hække & buske', 'Lugning af beder & flisearealer', 'Opsætning eller vedligehold af hegn'],
    tag: 'Sæsonklar have',
    timeEst: 'Halv eller hel dag'
  },
  {
    id: 'flytning',
    title: 'Flytning & Transport',
    slug: 'flytning-og-transport',
    icon: 'fa-solid fa-truck-moving',
    category: 'Flytning og transport',
    image: 'https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/shutterstock-2688458725.jpg',
    shortDescription: 'Flytning og transport af møbler og ting.',
    examples: ['Transport af tunge møbler', 'Hjælp til indpakning & bæring', 'Kørsel af byggematerialer', 'Levering af kasser & udstyr'],
    tag: 'Med rummelig bil',
    timeEst: 'Fleksibel aftale'
  },
  {
    id: 'rydning',
    title: 'Rydning & Affald',
    slug: 'rydning',
    icon: 'fa-solid fa-broom',
    category: 'Rydning',
    image: 'https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2118.jpeg',
    shortDescription: 'Rydning af loft eller kælder, herunder bortskaffelse af affald.',
    examples: ['Rydning af loftsrum & kældre', 'Bortskaffelse af haveaffald', 'Tømning af dødsbo / garage', 'Kørsel til genbrugsstationen'],
    tag: 'Fuld tømning',
    timeEst: 'Fra 2 timer'
  },
  {
    id: 'vedligeholdelse',
    title: 'Generel Vedligehold',
    slug: 'generel-vedligeholdelse',
    icon: 'fa-solid fa-house-chimney-crack',
    category: 'Generel vedligeholdelse',
    image: 'https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2086.jpeg',
    shortDescription: 'Generel vedligeholdelse og reparation i hjemmet – fra at skifte pærer til at lappe vægge.',
    examples: ['Udskiftning af pærer & spot', 'Skift af tætningslister', 'Rensning af tagrender', 'Smøring af dørhængsler & låse'],
    tag: 'Løbende pasning',
    timeEst: 'Aftales individuelt'
  }
];

export function TaskEstimator({ onSelectTask }) {
  const [activeCategory, setActiveCategory] = useState(TASK_CATEGORIES[0]);

  const handleTaskClick = (cat) => {
    setActiveCategory(cat);
    if (onSelectTask) {
      onSelectTask(cat.category);
    }
  };

  return (
    <section className="py-16 sm:py-20 bg-forest text-white relative overflow-hidden border-b border-forest-light/40">
      {/* Decorative background grid */}
      <div className="absolute inset-0 bg-grid-pattern-dark opacity-40 pointer-events-none" />
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-copper/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-sky-400/10 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-8 relative z-10">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 space-y-3">
          <div className="inline-flex items-center gap-2 bg-copper/20 text-copper-light border border-copper/40 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest shadow-xs">
            <i className="fa-solid fa-list-check text-sky-300" aria-hidden="true" />
            <span>Ydelser & Håndværkshjælp</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white font-display">
            Hvad skal du have hjælp til i dag?
          </h2>
          <p className="text-sand/80 text-base sm:text-lg">
            Vælg en ydelse nedenfor og se eksempler på opgaver og tidsestimater – eller indhent et tilbud skræddersyet til dit projekt.
          </p>
        </div>

        {/* Task Category Grid Selector */}
        <div className="bg-forest-dark/70 border border-white/15 p-3 sm:p-4 rounded-3xl backdrop-blur-xl shadow-2xl mb-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-2.5 sm:gap-3">
            {TASK_CATEGORIES.map((cat) => {
              const isSelected = activeCategory.id === cat.id;
              return (
                <button
                  key={cat.id}
                  onClick={() => handleTaskClick(cat)}
                  type="button"
                  className={`relative p-3 sm:p-3.5 rounded-2xl text-left transition-all duration-300 cursor-pointer flex flex-col justify-between overflow-hidden group ${
                    isSelected
                      ? 'bg-gradient-to-b from-copper via-copper to-copper-hover text-white shadow-xl shadow-copper/25 ring-2 ring-sky-300/90 -translate-y-1'
                      : 'bg-forest-surface/70 hover:bg-forest-surface text-sand/90 border border-white/10 hover:border-white/25 hover:-translate-y-0.5'
                  }`}
                >
                  {/* Top active indicator line */}
                  {isSelected && (
                    <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-sky-300 via-sky-200 to-sky-400 shadow-xs" />
                  )}

                  {/* Top content */}
                  <div>
                    <div className="flex items-center justify-between mb-2">
                      <div
                        className={`w-9 h-9 sm:w-10 sm:h-10 rounded-xl flex items-center justify-center text-base sm:text-lg transition-transform duration-300 group-hover:scale-110 ${
                          isSelected
                            ? 'bg-white/20 text-sky-200 shadow-inner'
                            : 'bg-forest/80 text-sky-300 border border-sky-300/20'
                        }`}
                      >
                        <i className={cat.icon} aria-hidden="true" />
                      </div>

                      {/* Active indicator dot */}
                      {isSelected ? (
                        <span className="flex h-2.5 w-2.5 relative">
                          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-300 opacity-75"></span>
                          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-sky-200"></span>
                        </span>
                      ) : (
                        <i
                          className="fa-solid fa-chevron-right text-[10px] text-sand/40 opacity-0 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all"
                          aria-hidden="true"
                        />
                      )}
                    </div>

                    <p className="font-extrabold text-xs sm:text-sm leading-tight tracking-tight">
                      {cat.title}
                    </p>
                  </div>

                  {/* Bottom badge */}
                  <div className="pt-2.5 mt-2 border-t border-white/10 flex items-center justify-between">
                    <span
                      className={`text-[10px] sm:text-[11px] font-semibold tracking-wide truncate ${
                        isSelected ? 'text-white/95' : 'text-sky-300/90'
                      }`}
                    >
                      {cat.tag}
                    </span>
                    {isSelected && (
                      <i className="fa-solid fa-circle-check text-xs text-sky-300 shrink-0 ml-1" aria-hidden="true" />
                    )}
                  </div>
                </button>
              );
            })}
          </div>
        </div>

        {/* Active Category Details Display */}
        <div className="bg-forest-surface border border-white/15 rounded-3xl p-6 sm:p-8 lg:p-10 shadow-2xl backdrop-blur-md grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          
          {/* Active Category Image */}
          <div className="lg:col-span-4">
            <div className="relative rounded-2xl overflow-hidden shadow-xl border-2 border-white/20 group aspect-4/3 lg:aspect-square bg-forest-dark">
              <img
                src={getCdnImageUrl(activeCategory.image, 800)}
                alt={activeCategory.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute top-3 left-3 bg-forest/90 border border-white/20 backdrop-blur-md text-white text-xs font-bold px-3 py-1 rounded-lg flex items-center gap-1.5 shadow-md">
                <i className={activeCategory.icon} aria-hidden="true" />
                <span>{activeCategory.title}</span>
              </div>
            </div>
          </div>

          {/* Active Category Description & Examples */}
          <div className="lg:col-span-8 space-y-5">
            <div className="flex flex-wrap items-center gap-3">
              <span className="bg-copper text-white text-xs font-bold px-3.5 py-1 rounded-full uppercase tracking-wider">
                {activeCategory.tag}
              </span>
              <span className="text-white text-xs sm:text-sm font-semibold flex items-center gap-1.5 bg-forest-dark/60 border border-white/10 px-3 py-1 rounded-full">
                <i className="fa-regular fa-clock" aria-hidden="true" />
                {activeCategory.timeEst}
              </span>
            </div>

            <div>
              <h3 className="text-2xl sm:text-3xl font-extrabold text-white flex items-center gap-3 font-display">
                <span>{activeCategory.title}</span>
              </h3>

              <p className="text-sand/90 text-base sm:text-lg mt-2 leading-relaxed">
                {activeCategory.shortDescription}
              </p>
            </div>

            <div>
              <p className="text-xs font-bold text-white uppercase tracking-wider mb-2">
                Typiske eksempler på opgaver:
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                {activeCategory.examples.map((ex, idx) => (
                  <div key={idx} className="flex items-start gap-2.5 bg-forest-dark/60 p-3 rounded-xl border border-white/10 text-sm text-sand/90">
                    <i className="fa-solid fa-check text-white mt-0.5 shrink-0" aria-hidden="true" />
                    <span>{ex}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Action Buttons for active category */}
            <div className="pt-3 border-t border-white/15 flex flex-wrap items-center gap-4">
              <Link
                to={`/ydelser/${activeCategory.slug}`}
                className="inline-flex items-center gap-2.5 bg-white text-forest hover:bg-sand font-bold px-6 py-3 rounded-xl shadow-md transition-all text-sm cursor-pointer"
              >
                <span>Læs alt om {activeCategory.title}</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>

              <a
                href="#kontakt-sektion"
                className="inline-flex items-center gap-2 bg-copper hover:bg-copper-hover text-white font-bold py-3 px-6 rounded-xl shadow-md transition-all text-sm cursor-pointer"
              >
                <i className="fa-solid fa-paper-plane text-xs" aria-hidden="true" />
                <span>Indhent uforpligtende tilbud</span>
              </a>
            </div>

          </div>

        </div>

        {/* Global link to full overview */}
        <div className="text-center mt-10">
          <Link
            to="/ydelser"
            className="inline-flex items-center gap-3 bg-white/10 hover:bg-white/20 border border-white/25 text-white font-bold px-8 py-4 rounded-xl transition-all cursor-pointer text-base backdrop-blur-xs"
          >
            <span>Se samlet oversigt over alle 7 ydelser</span>
            <i className="fa-solid fa-arrow-right" aria-hidden="true" />
          </Link>
        </div>

      </div>
    </section>
  );
}
